import { PasswordChecks, ProcessingOverlay, SettingsSection } from '@components'

import { Button, Color, FormItemsGroup, InputPassword } from '@billy/design-system'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { usePasswordForm } from '../../hooks/usePasswordForm'
import * as Styled from './styles'

export const PasswordForm = (): ReactElement => {
  const [isNewPasswordFocused, setIsNewPasswordFocused] = useState(false)
  const { Form, FormItem, isSubmitting: isProcessing, watch } = usePasswordForm()
  const { t } = useTranslation()
  const newPasswordValue = watch('newPassword')

  return (
    <SettingsSection>
      <Form name="user-password">
        <SettingsSection.Content title={t('settings.user.change_password')}>
          <Styled.FormFieldsWrapper>
            {isProcessing && <ProcessingOverlay color={Color.White} />}
            <FormItemsGroup>
              <FormItem
                label={t('change_password.old_password')}
                name="oldPassword"
                render={({ field }) => <InputPassword {...field} autoComplete="current-password" />}
              />
              <FormItem
                label={t('change_password.new_password')}
                name="newPassword"
                render={({ field }) => (
                  <InputPassword
                    {...field}
                    autoComplete="new-password"
                    onBlur={() => {
                      field.onBlur()
                      setIsNewPasswordFocused(false)
                    }}
                    onFocus={() => setIsNewPasswordFocused(true)}
                  />
                )}
              />
            </FormItemsGroup>
            {(isNewPasswordFocused || !!newPasswordValue) && (
              <Styled.PasswordChecksWrapper>
                <PasswordChecks value={newPasswordValue} />
              </Styled.PasswordChecksWrapper>
            )}
          </Styled.FormFieldsWrapper>
        </SettingsSection.Content>
        <SettingsSection.Footer>
          <Button loading={isProcessing} size="md" type="submit">
            {t('change_password.change_password')}
          </Button>
        </SettingsSection.Footer>
      </Form>
    </SettingsSection>
  )
}
